import { Container } from 'inversify';

/**
 * container に各 Model を登録する
 */
const container = new Container();

export default container;
